import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const GREAT_BRITAIN_DATABASE_COUNTRY_ID = 8;

export const GreatBritainCountryDefinition = {
  addressProvider: EAddressProvider.GOOGLE,
  countryCode: ECountryCode.GREAT_BRITAIN,
  languageCode: ELanguageCode.ENGLISH_UK,
  country: ECountry.GREAT_BRITAIN,
  phoneAllowed: true,
  addressAllowed: true,
  phone: {
    mask: "+44 99 9999 9999",
    placeholder: "+44 99 9999 9999",
    prefix: "+44",
  },
  databaseCountryId: 8,
} as const satisfies ICountryDefinition;
